module.exports = __webpack_public_path__ + "img/echalotte_en_bac_md.b73d1608.jpg";